import presignedUrlsActions from '../actions/PresignedUrlsActions';

export default function (state = {}, action) {
    switch (action.type) {
    case presignedUrlsActions.types.SET_PRESIGNED_URL:
        return Object.assign({}, state, {
            [action.identifier]: {
                presignedUrl: action.presignedUrl,
                timestamp: action.timestamp,
            },
        });
    default:
        return state;
    }
}
